<template>

  <div id="page-new-sector" class="vx-card p-6">

    <vx-card card-border class="mb-4" title="Detalle del sector" title-color="dark" collapseAction>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">Empresa *</span>
          </div>
          <div>
            <v-select class="w-full" v-model="sector.empresa" :options="empresasOptions" :reduce="id => `/api/empresas/${id.id}`" />
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div class="vx-col w-full mb-3">
            <span>Sector inactivo/activo</span>
          </div>
          <div class="vx-col w-full">
            <vs-switch vs-type="success" v-model="sector.activo"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">Nombre *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="NOMBRE" v-model="sector.nombre" v-validate="'required'" name="nombre" />
            <span class="text-danger text-sm"  v-show="errors.has('nombre')">{{ errors.first('nombre') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">Descripción *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="DESCRIPCIÓN" v-model="sector.descripcion" v-validate="'required'" 
              name="descripcion" />
            <span class="text-danger text-sm"  v-show="errors.has('descripcion')">{{ errors.first('descripcion') }}</span>
          </div>
        </div>
      </div>
      
      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="guardar" :disabled="!validateForm">Guardar</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
          </div>
        </div>
      </div>
    </vx-card>

  </div>

</template>


<script>
import empresasStore from '@/store/configuracion/empresas/index.js'
import vSelect from 'vue-select'

export default {
  components: {
    'v-select': vSelect
  },
  data () {
    return {
      empresas: [],
      sector: {
        descripcion: '',
        empresa: '',
        nombre: '',
        activo: false
      }
    }
  },
  computed: {
    validateForm () {
      if (this.errors.any() || this.sector.descripcion === '' || this.sector.empresa === null ||
        this.sector.empresa === '' || this.sector.nombre === '') {
        return false
      } else {
        return true
      }
    },
    empresasOptions () {
      // Combo de empresas
      const empresasOptions =  this.empresas.map(x => ({['id']: x.id, ['label']: x.nombre}))
      return empresasOptions
    }
  },
  methods: {
    guardar () {
      if (!this.validateForm) return
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      this.$store.dispatch('valSectoresStore/addSector', this.sector)
        .then(()   => { 
          this.$router.push({name:'valSectores'})
          this.showUpdateSuccess() 
        })
        .catch(err => { this.showUpdateError(err) })
    },
    showUpdateSuccess () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: 'Sector creado',
        text: 'El sector ha sido creado correctamente'
      })
    },
    showUpdateError () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'Error',
        text: 'El sector no ha podido ser creado.'
      })
    },
    reset_data () {
      this.$router.push({name:'valSectores'})
    }
  },
  async created () {
    this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
    if (!empresasStore.isRegistered) {
      this.$store.registerModule('empresasStore', empresasStore)
      empresasStore.isRegistered = true
    }

    await this.$store.dispatch('empresasStore/getEmpresas')
      .then(() => {
        // Recorremos as empresas e se están activas ou se teñen o mesmo id que o que ten asociado o usuario engadímolas ao combo
        this.$store.state.empresasStore.empresas.forEach(element => {
          if (element.activa) this.empresas.push(element)
        })
        this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      })
      .catch((error) => {
        console.log(error)
        this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      })
  }
}
</script>